import { FormHelperText, InputLabel, OutlinedInput, styled } from '@mui/material';

// Mode-aware: en OSCURO label/borde gris claro (#E3E7EB) + texto blanco (como antes);
// en CLARO label/borde NEGRO marcado + texto negro (sin esto la contraseña queda
// "abandonada" e invisible sobre la card blanca del login/registro). Foco en dorado.
const LIGHT_LABEL = 'rgba(17, 21, 27, 0.82)';
const LIGHT_BORDER = 'rgba(17, 21, 27, 0.6)';
const LIGHT_ICON = 'rgba(17, 21, 27, 0.7)';
const DARK_NEUTRAL = '#E3E7EB';

export const StyledInputLabel = styled(InputLabel)(({ theme }) => {
  const labelColor = theme.palette.mode === 'light' ? LIGHT_LABEL : DARK_NEUTRAL;

  return {
    '&.MuiInputLabel-root': {
      color: labelColor,
      '&.Mui-focused': {
        color: theme.palette.secondary.main
      },
      '&.Mui-error': {
        color: '#F6B1B1'
      },
      '&.Mui-disabled': {
        color: theme.palette.action.disabled,
        '.MuiInputLabel-asterisk': {
          color: theme.palette.action.disabled
        }
      }
    },
    '& .MuiInputLabel-asterisk': {
      color: labelColor,
      '&.Mui-error': {
        color: '#F6B1B1'
      }
    }
  };
});

export const StyledOutlineInput = styled(OutlinedInput)(({ theme }) => {
  const isLight = theme.palette.mode === 'light';
  const borderColor = isLight ? LIGHT_BORDER : DARK_NEUTRAL;
  const textColor = isLight ? theme.palette.text.primary : theme.palette.common.white;
  const iconColor = isLight ? LIGHT_ICON : DARK_NEUTRAL;

  return {
    '&.MuiOutlinedInput-root': {
      [theme.breakpoints.up('lg')]: {
        height: '47px'
      },
      '& fieldset': {
        border: `1px solid ${borderColor}`
      },
      '&:hover fieldset': {
        borderColor: theme.palette.secondary.main
      },
      '&.Mui-focused': {
        '& fieldset': {
          borderColor: theme.palette.secondary.main
        },
        '& .MuiIconButton-root': {
          color: theme.palette.secondary.main
        }
      },
      '&.Mui-error': {
        '& fieldset': {
          borderColor: '#F6B1B1'
        },
        '& .MuiIconButton-root': {
          color: '#F6B1B1'
        }
      },
      '&.Mui-disabled': {
        '& fieldset': {
          borderColor: theme.palette.action.disabled
        },
        '& .MuiIconButton-root': {
          color: theme.palette.action.disabled
        }
      }
    },
    '& .MuiOutlinedInput-input': {
      color: textColor,
      '&::placeholder': {
        color: iconColor,
        opacity: 1
      },
      '&.Mui-disabled': {
        color: theme.palette.action.disabled
      }
    },
    '& .MuiIconButton-root': {
      color: iconColor
    }
  };
});

export const StyledFormHelperText = styled(FormHelperText)({
  '&.MuiFormHelperText-root': {
    marginLeft: 0,
    '&.Mui-error': {
      color: '#F6B1B1'
    }
  }
});
